import styled from '@emotion/styled'

export const Title = styled.div`
	${({ theme, variant }) => theme.text[variant]};
`

Title.defaultProps = {
	variant: 'display1',
}
